var map = {
	"./account.svg": 2355,
	"./address-card.svg": 2742,
	"./appointments.svg": 8262,
	"./articles.svg": 7933,
	"./building.svg": 5953,
	"./checkbox.png": 1948,
	"./chevron-left-solid.svg": 1018,
	"./city.svg": 3174,
	"./close.svg": 4241,
	"./coins.svg": 6677,
	"./diagram.svg": 6199,
	"./eye.svg": 4171,
	"./fingerprint.svg": 3875,
	"./globe.svg": 3864,
	"./info.svg": 9519,
	"./logo.svg": 4829,
	"./map-marker.svg": 8478,
	"./notification-danger.svg": 6264,
	"./notification-info.svg": 3103,
	"./notification-success.svg": 9353,
	"./notification-warning.svg": 3776,
	"./plus.svg": 4132,
	"./specialists.svg": 5305,
	"./star-empty.png": 3344,
	"./star-full.png": 5574,
	"./star-half.png": 9185,
	"./topup.svg": 9141,
	"./user.svg": 9643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4140;